import { Box } from "@chakra-ui/react";

const StepPath = ({
    pathData,
    top,
    left,
    boxHeight
}: {
    pathData: string;
    top: string;
    left: string;
    boxHeight: number;
}) => (
    <Box
        position="absolute"
        top={top}
        left={left}
        transform="translateX(-50%)"
        transition="height 0.1s ease-in-out"
    >
        <svg width="200%" height={boxHeight} xmlns="http://www.w3.org/2000/svg">
            <path d={pathData} stroke="#FE3A3A" strokeWidth="3" fill="none" />
            {/* <circle cx="0" cy="50" r="5" fill="#FE3A3A" />
            <circle cx="536" cy="388" r="5" fill="#FE3A3A" /> */}
        </svg>
    </Box>
);

export default StepPath;
